import monomarkUrl from "@enrein/design-system/assets/enrein-monomark-v4.png";
import wordmarkUrl from "@enrein/design-system/assets/enrein-wordmark-v4.png";
import type { V10SidebarView } from "../routing/v10-views.js";
import { exposedV10SidebarViews } from "../routing/v10-views.js";

const SIDEBAR_LABELS: Record<V10SidebarView, string> = {
  today: "Today",
  projects: "Projects",
  portfolio: "Portfolio",
  inbox: "Client Portal",
  scans: "Scans / Proof",
  settings: "Settings",
};

export function V10Sidebar({
  activeView,
  onNavigate,
  onNewWork,
}: {
  readonly activeView: V10SidebarView;
  readonly onNavigate: (view: V10SidebarView) => void;
  readonly onNewWork: () => void;
}) {
  return (
    <aside className="v10-sidebar" aria-label="Studio navigation">
      <div className="v10-brand">
        <div className="v10-brand__mark">
          <img className="v10-brand__mono" src={monomarkUrl} alt="" width={46} height={46} />
        </div>
        <div className="v10-brand__lockup">
          <img className="v10-brand__wordmark" src={wordmarkUrl} alt="Enrein" width={116} height={28} />
          <div className="v10-brand__sub">Launch Proof OS</div>
        </div>
      </div>
      <p className="v10-nav-label">Primary nav</p>
      <nav className="v10-nav" aria-label="Primary">
        {exposedV10SidebarViews().map((view, index) => (
          <button
            key={view}
            type="button"
            className={activeView === view ? "active" : undefined}
            aria-current={activeView === view ? "page" : undefined}
            onClick={() => onNavigate(view)}
          >
            <span className="v10-nav-num" aria-hidden="true">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span>{SIDEBAR_LABELS[view]}</span>
          </button>
        ))}
      </nav>
      <button type="button" className="v10-new-work-btn" onClick={onNewWork}>
        + New Work
      </button>
    </aside>
  );
}
